/* eslint-disable indent */
import { SET_STEP_1, SET_STEP_2, SET_STEP_3, SET_STEP_4, SET_STEP_5 } from './constants'

export const initialState = {
  step1: {},
  step2: {},
  step3: {},
  step4: {},
  step5: {},
}

export const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SET_STEP_1:
      return { ...state, step1: payload }
    case SET_STEP_2:
      return { ...state, step2: payload }
    case SET_STEP_3:
      return { ...state, step3: payload }
    case SET_STEP_4:
      return { ...state, step4: payload }
    case SET_STEP_5:
      return { ...state, step5: payload }
    default:
      return state
  }
}
